export const registerCustomElements = () => {
  if (typeof window === "undefined" || !window.customElements) return;

  const elements = {
    "bbh-loading": class extends HTMLElement {},
    "bbh-nodata": class extends HTMLElement {},
    "bbh-charts": class extends HTMLElement {},
    "bbh-statistic": class extends HTMLElement {},
    "bbh-icons": class extends HTMLElement {},
    "bbh-widget": class extends HTMLElement {},
  };

  Object.entries(elements).forEach(([name, element]) => {
    if (!window.customElements.get(name)) {
      try {
        window.customElements.define(name, element);
      } catch {
        // ignore hot reload issues
      }
    }
  });
};
